<template>
    <div>
        <v-card
            class="products"
            outlined
        >
            <v-card-title class="page-heading primary">
                <v-row align="center">
                    <v-col
                        cols="12"
                        md="9"
                    >
                        {{ $t('products.heading') }}
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                        class="d-flex justify-end"
                    >
                        <div
                            class="text-center mr-4"
                            color="white"
                        >
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        dark
                                        v-bind="attrs"
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon left>fal fa-download</v-icon>
                                        {{ $t('general.export') }}
                                    </v-btn>
                                </template>
                                <v-list class="pa-0">
                                    <v-list-item :key="1" class="cursor-pointer">
                                        <v-list-item-title>
                                            <div
                                                color="white"
                                                outlined
                                                @click="exportProducts('xlsx')"
                                            >
                                                {{ $t('general.export_xml')}}
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item :key="2" class="cursor-pointer">
                                        <v-list-item-title>
                                            <div
                                                color="white"
                                                outlined
                                                @click="exportProducts('txt')"
                                            >
                                                {{ $t('general.export_scale') }}
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item
                                        v-if="!isAllegra"
                                        :key="3"
                                        class="cursor-pointer"
                                    >
                                        <v-list-item-title>
                                            <div
                                                color="white"
                                                outlined
                                                @click="exportIngredients()"
                                            >
                                                {{ $t('products.ingredients.export.title') }}
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                        <div
                            class="text-center mr-4"
                            color="white"
                        >
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        dark
                                        v-bind="attrs"
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon left>fal fa-upload</v-icon>
                                        {{ $t('general.import') }}
                                    </v-btn>
                                </template>
                                <v-list class="pa-0">
                                    <v-list-item
                                        :key="1"
                                        class="cursor-pointer"
                                    >
                                        <v-list-item-title>
                                            <div
                                                color="white"
                                                outlined
                                                @click="showImportProducts('generalImport')"
                                            >
                                                {{ $t('products.import.title') }}
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item
                                        :key="2"
                                        class="cursor-pointer"
                                        :disabled="inventoryAccountingEnabled"
                                    >
                                        <v-list-item-title>
                                            <div
                                                color="white"
                                                outlined
                                                @click="showImportProducts('updateImport')"
                                            >
                                                {{ $t('general.import_update') }}
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item
                                        v-if="!isAllegra"
                                        :key="3"
                                        class="cursor-pointer"
                                    >
                                        <v-list-item-title>
                                            <div
                                                color="white"
                                                outlined
                                                @click="toggleImportIngredients()"
                                            >
                                                {{ $t('products.ingredients.import.title') }}
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>

                        <v-btn
                            class="mr-3"
                            color="white"
                            outlined
                            @click="openProductForm()"
                        >
                            <v-icon left>fal fa-plus</v-icon>
                            {{ $t('general.add') }}
                        </v-btn>

                        <v-menu bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on }">
                                <v-btn color="white" v-on="on" icon>
                                    <v-icon>far fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>

                            <v-list class="order-menu">
                                <v-list-item
                                    :key="1"
                                    @click="$router.push({ name: 'adminProductsPriceTags' }).catch(err => {})"
                                >
                                    <v-list-item-action class="mx-3">
                                        <v-icon>fal fa-tags</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>
                                        {{ $t('general.price_tags_print') }}
                                    </v-list-item-title>
                                </v-list-item>

                                <!-- <v-list-item
                                    :key="2"
                                    @click="deleteAllProducts"
                                >
                                    <v-list-item-action class="mx-3">
                                        <v-icon class="error--text">fal fa-times</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title class="error--text">
                                        {{ $t('products.delete_all') }}
                                    </v-list-item-title>
                                </v-list-item> -->
                            </v-list>
                        </v-menu>

                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <div class="buttons-header">
                    <v-text-field
                        ref="filterField"
                        v-model="filter"
                        class="search"
                        :label="$t('general.search')"
                        append-icon="far fa-search"
                        clearable
                        clear-icon="fal fa-times"
                        single-line
                        hide-details
                        @focus="$refs.filterField.$refs.input.setSelectionRange(0, 10000)"
                        @input="filterProducts()"
                    />
                </div>

                <v-data-table
                    class="items-table operations striped"
                    :headers="headers"
                    :items="products"
                    :options.sync="pagination"
                    :footer-props="{'items-per-page-options': [20, 50, 100, 200]}"
                    :items-per-page.sync="pagination.itemsPerPage"
                    :loading="loading"
                    :server-items-length="totalItems"
                    :mobile-breakpoint="0"
                >
                    <template
                        slot="item"
                        slot-scope="props"
                    >
                        <tr>
                            <td class="minw150">{{ props.item.name }}</td>
                            <td>{{ props.item.code }}</td>
                            <td>{{ props.item.barcode }}</td>
                            <td>{{ props.item.is_goods ? $t('general.goods') : (props.item.is_goods !== null ? $t('general.service') : '') }}</td>
                            <td v-if="isAllegra">
                                <v-chip
                                    style="z-index: 0"
                                    small
                                    outlined
                                    :color="props.item.is_measured ? 'success' : 'error'"
                                >
                                    {{ props.item.is_measured ? $t('general.yes') : $t('general.no') }}
                                </v-chip>
                            </td>
                            <td v-if="!isAllegra">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-chip
                                            style="z-index: 0"
                                            small
                                            outlined
                                            :color="props.item.is_sold ? 'error' : 'success'"
                                            v-on="on"
                                        >
                                            {{ props.item.is_sold ? $t('general.no') : $t('general.yes') }}
                                        </v-chip>
                                    </template>
                                    <span v-if="props.item.is_sold">{{ $t('products.is_not_ingredient') }}</span>
                                    <span v-else>{{ $t('products.is_ingredient') }}</span>
                                </v-tooltip>
                            </td>
                            <td v-if="!isAllegra">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-chip
                                            style="z-index: 0"
                                            small
                                            outlined
                                            :color="props.item.is_made ? 'success' : 'error'"
                                            v-on="on"
                                        >
                                            {{ props.item.is_made ? $t('general.yes') : $t('general.no') }}
                                        </v-chip>
                                    </template>
                                    <span v-if="props.item.is_made">{{ $t('products.is_made') }}</span>
                                    <span v-else>{{ $t('products.is_not_made') }}</span>
                                </v-tooltip>
                            </td>
                            <td>{{ props.item.is_sold ? props.item.getSellingPrice().toFormat('0.00') : '/' }}</td>
                            <td>{{ props.item.tax_rate ? `${props.item.tax_rate.label} - ${props.item.tax_rate.rate}%` : '/' }}</td>
                            <td v-if="!tenant.venue.settings.hide_product_quantities">
                                {{ !props.item.is_made ? props.item.getCount() : '/' }}
                            </td>
                            <td>{{ !props.item.is_made ? (props.item.getUnitOfMeasureSold() || props.item.getUnitOfMeasure()) : '/' }}</td>
                            <td>{{ props.item.category ? props.item.category.name : '/' }}</td>
                            <td v-if="!isAllegra">{{ props.item.printing_sector ? $t(`products.printing_sector.${props.item.printing_sector}`) : '/' }}</td>
                            <td>{{ props.item.gtin }}</td>
                            <td
                                align="center"
                                class="w35 maxw60"
                            >
                                <v-menu
                                    bottom
                                    transition="slide-y-transition"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            v-on="on"
                                        >
                                            <v-icon>far fa-ellipsis-h</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <template v-if="props.item.is_made">
                                            <v-list-item
                                                :key="1"
                                                @click="viewProductDetails(props.item)"
                                            >
                                                <v-list-item-action class="mr-4 flex justify-content-center">
                                                    <v-icon>fal fa-eye</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-title>{{ $t('general.view_details') }}</v-list-item-title>
                                            </v-list-item>

                                            <v-divider />
                                        </template>

                                        <v-list-item
                                            :key="2"
                                            @click="copyProduct(props.item)"
                                        >
                                            <v-list-item-action class="mr-4 flex justify-content-center">
                                                <v-icon>fal fa-copy</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-title>{{ $t('general.copy') }}</v-list-item-title>
                                        </v-list-item>

                                        <v-divider />

                                        <v-list-item
                                            :key="3"
                                            @click="openProductForm(props.item)"
                                        >
                                            <v-list-item-action class="mr-4 flex justify-content-center">
                                                <v-icon>fal fa-pen</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-title>{{ $t('general.edit') }}</v-list-item-title>
                                        </v-list-item>

                                        <v-divider />

                                        <v-list-item
                                            :key="4"
                                            @click="deleteProduct(props.item)"
                                        >
                                            <v-list-item-action class="mr-4 flex justify-content-center">
                                                <v-icon class="error--text">fal fa-times</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-title class="error--text">
                                                {{ $t('general.delete') }}
                                            </v-list-item-title>
                                        </v-list-item>

                                    </v-list>
                                </v-menu>

                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <cod-dialog
            :show.sync="show.productForm"
            max-width="770px"
        >
            <span slot="header">
                <span v-if="!selectedProduct">{{ $t('products.add_product') }}</span>
                <span v-else-if="selectedProduct.id">{{ $t('products.edit_product') }}</span>
                <span v-else>{{ $t('products.copy_product') }}</span>
            </span>

            <div slot="content">
                <product-form
                    :product="selectedProduct"
                    :products="allProducts"
                    :pricelists="pricelists"
                    :product-categories="productCategories"
                    @save="onProductSaved"
                />
            </div>
        </cod-dialog>

        <cod-dialog
            id="productDetailsForm"
            :show.sync="show.productDetails"
        >
            <template v-if="selectedProduct" slot="header">
                <span>{{ selectedProduct.name + ' ' + $t('general.details') }}</span>
            </template>

            <div
                v-if="selectedProduct"
                slot="content"
                class="ingredients form-container"
            >
                <div
                    v-if="selectedProduct.is_made"
                    class="ingredients__row heading"
                >
                    <div class="ingredients__col1">{{ $tc('general.ingredient', 2) }}</div>
                    <div class="ingredients__col2">{{ $t('general.quantity') }}</div>
                </div>

                <div
                    v-for="ingredient in selectedProduct.ingredients"
                    :key="ingredient.id"
                    class="ingredients__row"
                >
                    <div class="ingredients__col1">{{ ingredient.name }}</div>
                    <div class="ingredients__col2">{{ parseFloat(ingredient.pivot.quantity) }} {{ ingredient.unit_of_measure }}</div>
                </div>
            </div>
        </cod-dialog>

        <cod-dialog
            id="syncWithScaleForm"
            :show.sync="show.syncWithScale"
        >
            <template slot="header">
                <div class="d-flex justify-space-between align-center wfull">
                    <span>{{ $t('products.scale_heading') }}</span>
                    <v-spacer />
                    <v-btn
                        v-if="!scaleFormEdit"
                        icon
                        @click="scaleFormEdit = true"
                    >
                        <v-icon size="22">fal fa-pen</v-icon>
                    </v-btn>
                </div>
            </template>

            <div
                slot="content"
                class="pa-4 mt-2"
            >
                <v-text-field
                    v-model="scaleForm.filePath"
                    class="mb-3"
                    outlined
                    :label="$t('products.scale_file_path')"
                    :hint="$t('products.scale_file_path_description')"
                    :error-messages="scaleForm.$errors.filePath"
                    :disabled="!scaleFormEdit"
                    @blur="scaleForm.validate('filePath')"
                    @input="delete scaleForm.$errors.filePath"
                    persistent-hint
                />

                <v-text-field
                    v-model="scaleForm.scriptPath"
                    outlined
                    :label="$t('products.scale_script_path')"
                    :hint="$t('products.scale_script_path_description')"
                    :error-messages="scaleForm.$errors.scriptPath"
                    :disabled="!scaleFormEdit"
                    @blur="scaleForm.validate('scriptPath')"
                    @input="delete scaleForm.$errors.scriptPath"
                    persistent-hint
                />
            </div>

            <template
                slot="footer"
                class="pa-4"
            >
                <v-btn
                    color="primary"
                    outlined
                    class="flex-1 mr-3"
                    :disabled="scaleForm.$busy"
                    @click="show.syncWithScale = false"
                >
                    {{ $t('general.cancel') }}
                </v-btn>

                <v-btn
                    color="primary"
                    depressed
                    class="flex-1"
                    :disabled="!scaleForm.filePath || scaleForm.$busy"
                    :loading="scaleForm.$busy"
                    @click="exportProducts('txt')"
                >
                    {{ $t('products.scale_execute') }}
                </v-btn>
            </template>
        </cod-dialog>

        <!-- Import and Update Products -->
        <cod-dialog :show.sync="show.importProducts">
            <template slot="header">
                <span v-if="selectedImport === 'generalImport'">
                    {{ $t('products.import.title') }}
                </span>
                <span v-if="selectedImport === 'updateImport'">
                    {{ $t('general.import_update') }}
                </span>
            </template>

            <div
                slot="content"
                class="pa-5"
            >
                <products-import
                    ref="productsImport"
                    :type-of-import="selectedImport"
                    @import="onProductsImported"
                    @error="onProductsImportFailed"
                />
            </div>

            <template slot="footer">
                <v-btn
                    color="primary"
                    outlined
                    class="flex-1 mr-3"
                    @click="show.importProducts = false"
                >
                    {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                    color="primary"
                    depressed
                    class="flex-1"
                    :disabled="importingProducts"
                    :loading="importingProducts"
                    @click="importProducts"
                >
                    {{ $t('general.import') }}
                </v-btn>
            </template>
        </cod-dialog>

        <!-- Import ingredients -->
        <cod-dialog :show.sync="show.importIngredients" max-width="860">
            <template slot="header">
                <span>
                    {{ $t('products.ingredients.import.title') }}
                </span>
            </template>

            <div
                slot="content"
                class="pa-5"
            >
                <span>
                    {{ $t('products.ingredients.heading', { columns: isAllegra ? 2 : 3 }) }}
                    <a href="file/normatives_example.xlsx" download>{{ $t('products.ingredients.download_here') }}</a>
                </span>

                <v-form ref="importIngredientsForm">
                    <v-file-input
                        v-model="ingredientsFile"
                        class="mt-5"
                        accept=".xlsx, .xls, .csv"
                        :label="$t('products.ingredients.file')"
                        clearable
                        outlined
                        prepend-inner-icon="fal fa-paperclip"
                        prepend-icon=""
                        clear-icon="fal fa-times"
                    />
                </v-form>

                <div class="pb-2">
                    <img src="/img/normatives_example.png" alt="normative_example" />
                </div>
            </div>

            <template slot="footer">
                <v-btn
                    color="primary"
                    outlined
                    class="flex-1 mr-3"
                    @click="toggleImportIngredients()"
                >
                    {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                    color="primary"
                    depressed
                    class="flex-1"
                    :disabled="!ingredientsFile || importingIngredients"
                    :loading="importingIngredients"
                    @click="importIngredients()"
                >
                    {{ $t('general.import') }}
                </v-btn>
            </template>
        </cod-dialog>
    </div>
</template>

<script>
import { loadData } from '@/views/shared/loadPageData';
import CodDialog from '@/components/CodDialog';
import Product from '@/models/Product';
import ProductCategory from '@/models/ProductCategory';
import TaxRate from '@/models/TaxRate';
import ApiService from '@/services/ApiService';
import ProductsImport from '@/views/shared/components/ProductsImport';
import ProductForm from '@/views/shared/components/ProductForm';

const SCALE_FILE_PATH = 'scale-file-path'
const SCALE_SCRIPT_PATH = 'scale-script-path'

export default {
    components: {
        CodDialog,
        ProductsImport,
        ProductForm,
    },

    created() {
        loadData('/admin/load/products').then(data => this.onDataLoaded(data));
    },

    data() {
        return {
            allProducts: [],
            productCategories: [],
            taxRates: [],
            pricelists: [],

            selectedProduct: null,

            products: [],
            filter: null,

            pagination: {
                sortBy: ['last_activity_at'],
                itemsPerPage: 100,
                page: 1,
                sortDesc: [true],
            },

            totalItems: 0,

            loading: false,
            importingProducts: false,
            importingIngredients: false,

            show: {
                productForm: false,
                productDetails: false,
                importProducts: false,
                importProductsUpdate: false,
                importIngredients: false,
                syncWithScale: false,
            },

            selectedImport: '',
            ingredientsFile: null,

            scaleForm: this.createScaleForm(),
            scaleFormEdit: false,
        };
    },

    computed: {
        headers() {
            const headers = [
                { text: this.$t('general.name'), value: 'name' },
                { text: this.$t('general.code'), value: 'code' },
                { text: this.$t('general.barcode'), value: 'barcode' }
            ]

            headers.push({ text: this.$t('general.goods') +  ' / ' + this.$t('general.service'), value: 'is_goods' })

            if(!this.isAllegra) {
                headers.push({ text: this.$t('products.is_ingredient_short'), value: 'is_sold' })
                headers.push({ text: this.$t('products.is_made_short'), value: 'is_made' })
            } else {
                headers.push({ text: this.$t('products.is_measured'), value: 'is_measured' })
            }

            headers.push({ text: this.$t('general.price'), value: 'selling_price' })
            headers.push({ text: this.$t('general.tax_rate'), value: 'tax_rate.label' })

            if(!this.tenant.venue.settings.hide_product_quantities) {
                headers.push({ text: this.$t('general.in_stock'), value: 'count' })
            }

            headers.push({ text: this.$t('products.unit'), value: 'unit_of_measure' })

            headers.push({ text: this.$t('general.category'), value: 'category.name' })

            if(!this.isAllegra) {
                headers.push({ text: this.$t('products.printing_sector.label'), value: 'printing_sector' })
            }

            headers.push({ text: this.$t('general.gtin_short'), value: 'gtin' })
            headers.push({ text: '', sortable: false })

            return headers
        },

        inventoryAccountingEnabled() {
            return !!this.tenant.venue?.settings?.use_inventory_accounting;
        },
    },

    watch: {
        pagination: {
            handler() {
                this.getProducts();
            },
            deep: true
        },
    },

    methods: {
        onDataLoaded(data) {
            this.allProducts = data.products.map(item => {
                const product = new Product(item);
                product.ingredients = item.ingredients;
                return product;
            });

            this.productCategories = data.productCategories.map(item => new ProductCategory(item));
            this.taxRates = data.taxRates.map(item => new TaxRate(item));
            this.pricelists = data.pricelists;
        },

        /**
         * Get Paginated, Filtered and Sorted products from server
         */
        getProducts() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
            const sortField = sortBy[0] ? sortBy[0] : 'name';
            const sortOrder = sortDesc[0] ? 'descending' : 'ascending';

            let url = `/admin/products?page=${page}&itemsPerPage=${itemsPerPage}&sortField=${sortField}&sortOrder=${sortOrder}`;

            if (this.filter) url += '&filter=' + this.filter;

            this.loading = true;
            ApiService.get(url).then(response => {
                this.loading = false;

                this.products = response.data.data.map(p => {
                    const product = new Product(p);
                    product.category = p.category ? new ProductCategory(p.category) : null;
                    product.tax_rate = p.tax_rate ? new TaxRate(p.tax_rate) : null;
                    product.ingredients = p.ingredients;
                    return product;
                });

                this.productCategories = response.data.categories.map(c => new ProductCategory(c));
                this.totalItems = response.data.total;
            });
        },

        /**
         * Filter Products
         */
        filterProducts: _.debounce(function() {
            this.getProducts();
        }, 700),

        /**
         * View secondary price (if it's set) and ingredients (if item is made out of ingredients)
         */
        viewProductDetails(product) {
            this.selectedProduct = product;
            this.show.productDetails = true;
        },

        /**
         * Copy the product as new
         * @param product
         */
        copyProduct(product) {
            let productCopy = product.$duplicate();
            productCopy.id = null;
            productCopy.name = null;

            this.openProductForm(productCopy);
        },

        /**
         * Open product form to add or edit a product
         * @param product
         */
        openProductForm(product = null) {
            this.selectedProduct = product;
            this.show.productForm = true;
        },

        /**
         * On product saved handle the updated data and close the form
         * @param data
         */
        onProductSaved(data) {
            this.show.productForm = false;

            const productsIndex = this.products.findIndex(item => item.id === data.product.id);
            if(productsIndex != -1) {
                this.$set(this.products, productsIndex, data.product);
            } else {
                this.products.unshift(data.product);
                this.totalItems++;
            }

            const allProductsIndex = this.allProducts.findIndex(item => item.id === data.product.id);
            if(allProductsIndex != -1) {
                this.$set(this.allProducts, allProductsIndex, data.product);
            } else {
                this.allProducts.push(data.product);
            }

            if(!data.category) return;

            const categoriesIndex = this.productCategories.findIndex(item => item.id === data.category.id);
            if(categoriesIndex != -1) {
                this.$set(this.productCategories, categoriesIndex, data.category);
            } else {
                this.productCategories.push(data.category);
            }
        },

        /**
         * Delete Product
         * @param product
         */
        deleteProduct(product) {
            const usedAsIngredient = this.allProducts.map(p => p.ingredients).flat()
                .map(i => i.pivot).flat()
                .find(i => i.product_id === product.id);

            if (usedAsIngredient) {
                this.$snackbar(this.$t('products.has_super_products'), 'error', { mode: 'multi-line' });
                return;
            }

            if (product.is_made && product.ingredients.length > 0) {
                this.$snackbar(this.$t('products.cannot_delete_made_product'), 'error', { mode: 'multi-line' });
                return;
            }

            this.$confirm(this.$t('products.permanently_delete'), {
                buttonTrueText: this.$t('general.confirm'),
                icon: 'fal fa-times',
                color: 'error',
                title: this.$t('general.delete')
            }, result => {
                if (!result) return;

                this.show.productForm = false;
                ApiService.delete(`/admin/products/${product.id}`, {}).then(response => {
                    this.totalItems--;
                    this.products = this.products.filter(item => item.id !== product.id);
                    this.allProducts = this.allProducts.filter(item => item.id !== product.id);
                    this.$snackbar(this.$t('products.deleted'), 'success');

                    product.$delete();
                }).catch(error => {
                    const errors = error.response.data ? error.response.data.errors : null

                    if (errors && errors.length && errors[0].code === 'has_super_products') {
                        this.$snackbar(this.$t('products.has_super_products'), 'error');
                    } else if (errors && errors.length && errors[0].code === 'has_dispatches'){
                        this.$snackbar(this.$t('products.has_dispatches'), 'error');
                    } else if (errors && errors.length && errors[0].code === 'has_receptions'){
                        this.$snackbar(this.$t('products.has_receptions'), 'error');
                    } else if (errors && errors.length && errors[0].code === 'has_calculations'){
                        this.$snackbar(this.$t('products.has_calculations'), 'error');
                    }
                });
            });
        },

        /**
         * Export Products
         */
        async exportProducts(type) {
            if(type === 'txt' && !this.show.syncWithScale) {
                this.scaleForm = this.createScaleForm();
                this.scaleFormEdit = !this.scaleForm.filePath && !this.scaleForm.scriptPath;
                this.show.syncWithScale = true;
                return;
            }

            if(type === 'txt' && this.show.syncWithScale && !this.scaleForm.validate()) return;

            const url = type === 'txt' ? 'export-txt' : 'export';

            const response = await ApiService.get(`/admin/products/${url}`, { responseType: 'blob' });
            const fileBlob = new Blob([response.data]);

            if(type === 'txt') {
                AppStorage.local().setItem(SCALE_FILE_PATH, this.scaleForm.filePath);
                AppStorage.local().setItem(SCALE_SCRIPT_PATH, this.scaleForm.scriptPath);

                const content = await fileBlob.text();

                this.scaleForm.startProcessing();
                const writeFileResult = await electron.invoke('el-write-file', {
                    path: this.scaleForm.filePath,
                    content: content
                });

                if(!writeFileResult.success) {
                    this.$snackbar(writeFileResult.error, 'error', {
                        title: this.$t('products.scale_execute_error')
                    });

                    console.log(writeFileResult);
                    this.scaleForm.finishProcessing();
                    return;
                }

                if(this.scaleForm.scriptPath) {
                    const execScriptResult = await electron.invoke('el-exec-file', {
                        path: this.scaleForm.scriptPath,
                        content: content
                    });

                    if(!execScriptResult.success) {
                        this.$snackbar(execScriptResult.error, 'error', {
                            title: this.$t('products.scale_execute_error')
                        });

                        console.log(execScriptResult);
                        this.scaleForm.finishProcessing();
                        return;
                    }
                }

                this.scaleForm.finishProcessing();
                this.$snackbar(this.$t('products.scale_execute_success'), 'success');
                this.show.syncWithScale = false;
                return;
            }

            const href = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', this.$t('general.products_file') + '.' + type);
            document.body.appendChild(link);
            link.click();
        },

        /**
         * On Product Import Finished
         */
        showImportProducts(importOption) {
            if(this.$refs.productsImport) {
                this.$refs.productsImport.reset()
            }

            this.selectedImport = importOption;
            this.show.importProducts = true;
        },
        /**
         * Import products
         */
        async importProducts() {
            this.importingProducts = true
            await this.$refs.productsImport.importFile()
            this.importingProducts = false
        },

        /**
         * On Product Import Finished
         */
        onProductsImported() {
            this.show.importProducts = false;
            this.show.importProductsUpdate = false;
            this.$snackbar(this.$t('products.import.success'), 'success');
            this.getProducts();
        },

        /**
         * On Product Import Error
         */
        onProductsImportFailed() {
            this.$snackbar(this.$t('products.import.fail'), 'error');
        },

        /**
         * Delete all existing products
         */
        deleteAllProducts() {
            this.$confirm(
                this.$t('products.delete_all_warning'),
                {
                    buttonTrueText: this.$t('general.confirm'),
                    icon: 'fal fa-times',
                    color: 'error',
                    title: this.$t('products.delete_all')
                },
                async result => {
                    if (!result) return;

                    await ApiService.delete('/admin/products/delete', {})
                    this.$snackbar(this.$t('products.delete_all_success'), 'success');

                    this.products = [];
                    this.allProducts = [];
                    this.totalItems = 0;
                    Product.deleteAll();
                }
            );
        },

        createScaleForm() {
            const defaultFilePath = AppStorage.local().getItem(SCALE_FILE_PATH);
            const defaultScriptPath = AppStorage.local().getItem(SCALE_SCRIPT_PATH);

            const filePath = defaultFilePath || (this.device?.operatingSystem === 'windows' ? 'C:\\BIZERBA\\plst.txt' : null);
            const scriptPath = defaultScriptPath || (this.device?.operatingSystem === 'windows' ? 'C:\\BIZERBA\\PUNJENJE_BS_PLST.bat' : null);

            return new Form(this, 'scaleForm', {
                filePath: filePath,
                scriptPath: scriptPath,
            });
        },

        /**
         * Export Ingredients
         */

        async exportIngredients() {
            try {
                const response = await ApiService.get(`/admin/products/export-ingredients`, { responseType: 'blob' });
                const fileBlob = new Blob([response.data]);

                const href = window.URL.createObjectURL(fileBlob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', this.$t('general.product_ingredients_file') + '.xlsx');
                document.body.appendChild(link);
                link.click();

                this.$snackbar(this.$t('products.ingredients.export.success'), 'success');
            } catch (error) {
                console.log(error);
                this.$snackbar(this.$t('products.ingredients.export.fail'), 'error');
            }
        },

        /**
         * Show Import Ingredients
         */
        toggleImportIngredients() {
            this.ingredientsFile = null
            this.show.importIngredients = !this.show.importIngredients;
        },

        /**
         * Import Ingredients
         */
        async importIngredients() {
            const formData = new FormData();
            formData.append('products', this.ingredientsFile);

            if (!this.$refs.importIngredientsForm.validate()) return false
            this.importingIngredients = true

            try {
                await ApiService.post('/admin/products-ingredients/import', formData, {
                    transformRequest: (data, headers) => {
                        headers.common['Content-Type'] = 'multipart/form-data';
                        return data;
                    }
                });

                this.show.importIngredients = false;
                this.$snackbar(this.$t('products.ingredients.import.success'), 'success');
            } catch (error) {
                console.log(error);
                this.$snackbar(this.$t('products.ingredients.import.fail'), 'error');
                this.ingredientsFile = null
            }

            this.importingIngredients = false;
        },
    }
};
</script>

<style lang="scss" scoped>
.products {
    .page-heading {
        padding: 12px 16px;
        color: white;
        font-size: 16px;
        word-break: break-word;
    }

    .buttons-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        @media screen and (max-width: 599px) {
            flex-wrap: wrap;
            justify-content: flex-end;
            height: unset;
        }

        .search {
            margin-bottom: 10px;
            padding-bottom: 5px;
            height: 50px;
            @media screen and (min-width: 600px) {
                max-width: 450px;
            }
        }
    }
}

::v-deep .items-table {
    th {
        font-size: 11px;
        padding: 0 4px;
        max-width: 80px;

        span {
            white-space: break-spaces;
        }
    }
}


.ingredients {
    padding: 10px;
    color: black;

    .ingredients__row {
        display: flex;
        height: 30px;

        &.heading {
            font-weight: bold;
        }

        .ingredients__col1 {
            padding: 0 10px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid lightgrey;
            width: 150px;
        }

        .ingredients__col2 {
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            border-bottom: 1px solid lightgrey;
            width: 100px;
        }

        &:last-child {
            .ingredients__col1, .ingredients__col2 {
                border-bottom: none;
            }
        }
    }

    tbody th,
    td {
        min-width: 200px;
    }

    tr {
        th:last-child,
        td:last-child {
            min-width: 50px;
        }
    }
}

.form-container {
    min-height: 495px;
}

img {
    max-height: 100%;
    max-width: 800px;
}

</style>
